import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/whatsapp-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M224 122.8C151.3 122.8 92.2 181.9 92.1 254.6 92.1 279.5 99.1 303.8 112.3 324.7L115.4 329.7 102.1 378.3 152 365.2 156.8 368.1C177 380.1 200.2 386.5 223.9 386.5H224C296.6 386.5 357.3 327.4 357.3 254.7 357.3 219.5 342.1 186.4 317.2 161.5 292.2 136.5 259.2 122.8 224 122.8zM301.5 311.2C298.2 320.5 282.4 328.9 274.8 330 262.2 331.9 252.4 330.9 227.3 320.1 187.6 302.9 161.6 262.9 159.6 260.3 157.6 257.7 143.4 238.8 143.4 219.3S153.6 190.2 157.3 186.2C160.9 182.2 165.2 181.2 167.9 181.2 170.5 181.2 173.2 181.2 175.5 181.3 177.9 181.4 181.2 180.4 184.4 188.1 187.7 196 195.6 215.5 196.6 217.5S198.3 221.8 196.9 224.4C189.3 239.6 181.2 239 185.3 246 200.6 272.3 215.9 281.4 239.2 293.1 243.2 295.1 245.5 294.8 247.8 292.1 250.1 289.5 257.7 280.5 260.3 276.6 262.9 272.6 265.6 273.3 269.2 274.6 272.8 275.9 292.3 285.5 296.3 287.5S302.9 290.5 303.9 292.1C304.8 294 304.8 302 301.5 311.2zM400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM223.9 413.2C197.3 413.2 171.2 406.5 148.1 393.9L64 416 86.5 333.8C72.6 309.8 65.3 282.5 65.3 254.5 65.4 167.1 136.5 96 223.9 96 266.3 96 306.1 112.5 336.1 142.5 366 172.5 384 212.3 384 254.7 384 342.1 311.3 413.2 223.9 413.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/whatsapp-square.js
// module id = XHoc
// module chunks = 144